/* eslint-disable react/jsx-no-useless-fragment */
import { useState, useContext, useReducer } from 'react'
import { useNavigate } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'

import useViewport from 'hooks/useViewport'

import { UserContext } from 'contexts/user'
import { trackEvent } from 'analytics/trackFunctions'
import handleNotification from 'utils/toast/handleNotification'
import { sendDataToGoogleSheets } from 'api/googleSheet'

// Components + assets
import ModalContainer from 'components/ModalContainer'
import { TextDivider } from 'components/Divider'
import CardButton from 'components/CardButtons'
import TextInputField from 'components/input'
import PrimaryButton from 'components/primaryButton'
import { FireMembership } from 'assets/icons'
import RoundedIcon from 'components/RoundedIcon'
import { HUB_BUTTONS, HUB_MODALS } from 'constants/hub'

import { initialStateLoading, reducer } from './membershipReducer'

const suggestions = 'Sugerencias'

const ActiveMembership = () => {
  const navigate = useNavigate()
  const { user } = useContext(UserContext)
  const { isMobile } = useViewport()
  const [selectedBenefit, setSelectedBenefit] = useState(null)
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const [event, dispatchEvent] = useReducer(reducer, initialStateLoading)
  const { errorToast } = handleNotification()
  const { control, reset } = useForm()

  function handleSuggestion(e) {
    e.preventDefault()
    dispatchEvent({ type: 'FINISHED_FORM_LOADING' })

    const formEle = document.querySelector('form')
    const formDatab = new FormData(formEle)
    const inputValue = e.target[0]?.value
    if (inputValue !== '') {
      sendDataToGoogleSheets(formDatab).then((res) => {
        if (res.status === 200) {
          dispatchEvent({ type: 'FINISHED_FORM_LOADING' })
          // successToast('¡La sugerencia se envió correctamente!')
          dispatchEvent({ type: 'SUGGESTION_REQUEST' })

          // Clear form after submit
          reset()
        }
        if (!res.ok) {
          errorToast(
            'La sugerencia no se pudo enviar, intentalo más tarde por favor.'
          )
          dispatchEvent({ type: 'SUGGESTION_REQUEST' })
        }
        dispatchEvent({ type: 'FINISHED_FORM_LOADING' })
      })
    } else {
      errorToast('Envía un sugerencia válida, por favor')
      dispatchEvent({ type: 'FINISHED_FORM_LOADING' })
    }
  }

  return (
    <div className='flex flex-col items-center w-full'>
      <RoundedIcon
        className='my-2 !h-12 !w-12'
        icon={<FireMembership className='w-[21px]' />}
      />
      <h2 className='text-2xl font-bold leading-[22px] text-center'>
        Disfrutá al máximo con tu <br /> suscripción a Wayni
        <span className='text-green-800 font-bold'>+</span>
      </h2>

      <div className='mt-8 !w-full flex flex-col items-center gap-3 md:grid md:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_1fr_1fr] xl:gap-x-6 md:items-end'>
        {HUB_BUTTONS.map((item) => (
          <CardButton
            key={item.id}
            icon={item.icon}
            title={item.title}
            onClick={() => {
              trackEvent({ eventName: item.eventName })
              setSelectedBenefit(item.id)
              setModalIsOpen(true)
            }}
            description={item.description || null}
            badge={item.badge || null}
          />
        ))}
      </div>

      <TextDivider text='Más información' className='my-8' />
      <div
        data-testid='suggestionBox'
        className='flex w-full text-black text-center items-center justify-center flex-col lg:w-[480px]'
      >
        <h1 className='text-xl font-bold leading-5 mb-2'>
          En <span className='text-green-800'>Wayni</span> te escuchamos
        </h1>
        {event.isHidden ? (
          <p className='text-xl font-medium leading-5 mb-6'>
            ¡Gracias por darnos tu opinión!
          </p>
        ) : (
          <>
            <p className='font-medium leading-4 mb-4'>
              Contanos qué otros beneficios te gustarían
            </p>
            <form
              name='suggestion-form'
              data-testid='suggestion-form'
              onSubmit={(e) => handleSuggestion(e)}
              className='w-full text-left'
            >
              <Controller
                name={suggestions}
                control={control}
                defaultValue=''
                render={({ field }) => (
                  <TextInputField
                    {...field}
                    id={suggestions}
                    name={suggestions}
                    inputType={isMobile ? 'text' : 'textarea'}
                    label='Escribí el beneficio que necesitás'
                    maxLength={40}
                  />
                )}
              />
              <PrimaryButton
                type='submit'
                className='my-6 '
                buttonText='Solicitar beneficio'
                dataTestId='soliciteButton'
                primaryButtonFunction={() => ''}
                isLoading={event.isFormLoading}
                isDisabled={event.isFormLoading}
              />
            </form>
          </>
        )}
      </div>

      {selectedBenefit ? (
        <ModalContainer
          title={HUB_MODALS[selectedBenefit].title}
          setModalFunction={setModalIsOpen}
          isShown={modalIsOpen}
          className='max-w-[25.5rem]'
        >
          <div className='mx-auto text-center font-medium text-base'>
            <RoundedIcon
              className='w-28 h-28 mx-auto mb-6'
              icon={
                <img
                  src={HUB_MODALS[selectedBenefit].icon}
                  className='w-15 h-auto'
                  alt=''
                />
              }
            />
            {HUB_MODALS[selectedBenefit].content}
          </div>
          <PrimaryButton
            className='mt-8'
            primaryButtonFunction={() =>
              HUB_MODALS[selectedBenefit].action({
                navigate,
                token: user.access_token
              })
            }
            buttonText={HUB_MODALS[selectedBenefit].buttonText}
          />
        </ModalContainer>
      ) : null}
    </div>
  )
}

export default ActiveMembership
